// Curated activity emojis plus Unicode Emoticons block (unidata16), deduped,
// then zodiac / Ophiuchus symbols (deduped).
// Order: activity list first (stable), then emoticons not already present, then zodiac.
import * as unidata from 'unidata16';
import { activityEmojis } from './activityEmojis';

const codePointToEmoji = (codePoint) => String.fromCodePoint(codePoint);

const getEmoticonCharacters = () => {
  const rows = unidata.getCharacters(unidata.CharacterSetType.Emoticons);
  return rows.map((row) => codePointToEmoji(row.code));
};

function mergeUnique(primary, secondary) {
  const seen = new Set();
  const out = [];
  for (const item of primary) {
    if (seen.has(item)) continue;
    seen.add(item);
    out.push(item);
  }
  for (const item of secondary) {
    if (seen.has(item)) continue;
    seen.add(item);
    out.push(item);
  }
  return out;
}

const ZODIAC_EMOJIS = [
  '♈',
  '♉',
  '♊',
  '♋',
  '♌',
  '♍',
  '♎',
  '♏',
  '♐',
  '♑',
  '♒',
  '♓',
  '⛎',
];

function appendUnique(base, extra) {
  const seen = new Set(base);
  const out = [...base];
  for (const item of extra) {
    if (seen.has(item)) continue;
    seen.add(item);
    out.push(item);
  }
  return out;
}

export const activityPlusEmoticonEmojis = appendUnique(
  mergeUnique(activityEmojis, getEmoticonCharacters()),
  ZODIAC_EMOJIS
);

export const getRandomActivityPlusEmoticonEmojis = (count = 10) => {
  const shuffled = [...activityPlusEmoticonEmojis].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, count);
};

export default activityPlusEmoticonEmojis;
